jQuery(function($) {
    if (!$(".awards_listing").length) return;
  
    var awardsContent = $(".awards_listing");
    var toggles = awardsContent.find(".toggle");
    console.log(toggles)
  
    toggles.click(function() {
      
      var prev = $(this).prev()
      var siblings = prev.siblings('div:visible');
      var year = prev.data('year')
      var text = 'VIEW ' + year + ' ACCOLADES'
    //   var next = siblings.next();
      console.log(siblings)
      if ($body.hasClass("page-template-page-awards") && prev.is(':hidden')) {
        // siblings.slideUp();
        prev.slideDown();
        $(this).addClass('open')
        prev.focus();
        $(this).text("CLOSE ACCOLADES");
        // next.text("View Details");
      } else {
        prev.slideUp();
        prev.focus();
        $(this).removeClass('open')
        $(this).text(text);
      }
    });
  });
  